import src from './source';

/**
 * liuzy 异步联动控制器
 * 控制联动顺序、控制联动请求的结果需都正常返回才允许流程提交
*/

const orderInfo = {};

//异步联动发请求前调用,生成异步联动key对象，以每个联动设置为维度
//同一个key下多个请求并发，最后一个请求的response才为有效结果
export const generateKeyOrder = (linkageType, reqParams) =>{
    let keyOrder = [];
    const linkageidArr = reqParams.linkageid.split(",");
    linkageidArr && linkageidArr.map(k =>{
        if(k !== ""){
            const rowIndexStr = reqParams["rowIndexStr_"+k] || "-1";
            const keyid = `${linkageType}_${k}_${rowIndexStr}`;
            keyOrder.push({keyid, linkageid:k, orderid:appendOrderInfo(keyid)});
        }
    });
    return keyOrder;
}

//生成顺序
const appendOrderInfo = (key) => {
    if(key in orderInfo)
        orderInfo[key].index++;
    else
        orderInfo[key] = {index:0};
    orderInfo[key].time = new Date().getTime();
    orderInfo[key].finished = false;
    return orderInfo[key].index;
}

//联动结果response赋值前调用，移除无效的结果
export const removeInvalidResponse = (keyOrder, resData) =>{
    keyOrder.map(item =>{
        const { keyid,linkageid,orderid } = item;
        if(orderid >= orderInfo[keyid].index){  //最新请求的response
            orderInfo[keyid].finished = true;
        }else{      //先发后置的无效response
            if(`assignInfo_${linkageid}` in resData)
                delete resData[`assignInfo_${linkageid}`];
        }
    });
    return resData;
}

//流程提交时调用，判断异步联动结果是否都正常返回
//如果存在联动未返回，定时器扫描等待，超过2s给提示信息，超过10s作为联动失败处理允许继续提交
export const verifyLinkageFinished = (callback) =>{
    const verifyLoadLinkageComplete = (cb) =>{
        const verifyTime = new Date().getTime();
        const timer = window.setInterval(function(){
            const currentTime = new Date().getTime();
            const completeFn = () =>{
                window.clearInterval(timer);
                cb();
            }
            if(window.Has_Trigger_Load_Linkage === true){
                completeFn();
            }else if(currentTime - verifyTime > 5*1000 && window.Has_Trigger_Load_Linkage !== true){
                window.WfForm.showMessage("页面加载未正常触发联动，请联系管理员！", 1, 30);
            }
        }, 500);
    }
    const verifyFormulaLoadComplete = (cb) => {
        //提交前校验公式资源/明细表/代码块/自定义页面加载是否完毕 并给出提示
        if (!judgeSubmitSource()) {
            //不给出提示的场景下，若出现明细表未加载完成，直接放行提交，因为后续会记录日志
            const wfVerifiySourceObj = getWfVerifiySourceObj();
            if (wfVerifiySourceObj.detailData === "loading") {
                cb();
            } else {
                verifyLoadLinkageComplete(cb)
            }
        };
    }
    try{
        let hasNotice = false;
        const timer = window.setInterval(function(){
            let linkageBegTime = "";
            let unFinishedKey = "";
            for(const key in orderInfo){
                if(!orderInfo[key].finished){
                    linkageBegTime = orderInfo[key].time;
                    unFinishedKey = key;
                    break;
                }
            }
            const submitBegTime = new Date().getTime();
            if(linkageBegTime === "" || submitBegTime - linkageBegTime > 60*1000){
                window.clearInterval(timer);
                window.wfform.appendSubmitParam({"linkageUnFinishedKey": unFinishedKey});
                verifyFormulaLoadComplete(callback);
            }else if(submitBegTime - linkageBegTime > 2*1000 && !hasNotice){
                window.WfForm.showMessage("存在联动请求未返回，请耐心等待...", 1, 60);
                hasNotice = true;
            }
        }, 200);
    }catch(e){
        verifyFormulaLoadComplete(callback);
    }
}

/**
 * "unload":资源未加载
 * "loading":资源加载中
 * "loaded":资源加载成功
 * "fail":资源加载失败
 */
const wfVerifiySourceObj={
    formularSource:"unload",
    scriptCusSource:"unload",
    detailData:"unload"
}

export const initVerifiySource=()=>{
    const {  controlVariableMap } = src.globalStore;
    controlVariableMap("wfVerifiySourceObj",wfVerifiySourceObj);
}

export const setWfVerifiySource=(sourceName,value)=>{
    const {  variableMap, controlVariableMap } = src.globalStore;
    const wfVerifiySourceObj = variableMap.get("wfVerifiySourceObj");
    let new_wfVerifiySourceObj = {
        ...wfVerifiySourceObj,
        [sourceName]:value
    }
    controlVariableMap("wfVerifiySourceObj",new_wfVerifiySourceObj);
}

export const getWfVerifiySourceObj=()=>{
    const {  variableMap } = src.globalStore;
    const wfVerifiySourceObj = variableMap.get("wfVerifiySourceObj");
    return wfVerifiySourceObj
}

/**
 * 拦截提交
 * 当没有开启开关才拦截提交
 */
export const judgeSubmitSource = () => {
    const { propFileCfg } = src.layoutStore;
    const { setBtnDisabled, setLoading } = src.globalStore;
    const { enable_no_promptes_submit = 0 } = propFileCfg;
    const wfVerifiySourceObj = getWfVerifiySourceObj();
    console.log("wfVerifiySourceObj", wfVerifiySourceObj)
    if (!(enable_no_promptes_submit == 1 || window.code_enable_submit)) {//给出提示，拦截提交，但不记录日志
        let tip_content = "";
        if (wfVerifiySourceObj.formularSource === "loading") {
            tip_content = src.getLabel(546602, "公式资源未加载完成，流程提交可能存在数据异常")
        } else if (wfVerifiySourceObj.scriptCusSource === "loading") {
            tip_content = src.getLabel(546603, "代码块/自定义页面资源未加载完成，流程提交可能存在数据异常")
        } else if (wfVerifiySourceObj.detailData === "loading") {
            tip_content = src.getLabel(546604, "明细表数据未加载完成，流程提交可能存在数据异常")
        } else if (wfVerifiySourceObj.formularSource === "fail") {
            tip_content = src.getLabel(546605, "公式资源加载失败，流程提交可能存在数据异常")
        } else if (wfVerifiySourceObj.scriptCusSource === "fail") {
            tip_content = src.getLabel(546606, "代码块/自定义页面资源加载失败，流程提交可能存在数据异常")
        } else if (wfVerifiySourceObj.detailData === "fail") {
            tip_content = src.getLabel(546607, "明细表数据加载失败，流程提交可能存在数据异常")
        }
        if (tip_content) {
            window.WfForm.showMessage(tip_content, 1, 3);
            window.WfForm.controlBtnDisabled(false);//移动端按钮取消置灰
			setBtnDisabled(false);//pc端按钮取消置灰
            setLoading(false)
            return true;
        }
    }
    //否则不给出提示，但记录日志
    return false;
}

/**
 * 记录日志
 * 当开启开关才记录日志
 */
export const setFormularErrorLog = async () => {
    const { propFileCfg } = src.layoutStore;
    const { commonParam, variableMap } = src.globalStore;
    const { requestid, workflowid, nodeid, currentUserid } = commonParam;
    const { enable_no_promptes_submit = 0 } = propFileCfg;
    const wfVerifiySourceObj = getWfVerifiySourceObj();
    if ((enable_no_promptes_submit == 1 || window.code_enable_submit)) {//记录日志
        let errMsg = "";
        let type = "";
        if (wfVerifiySourceObj.formularSource === "loading") {
            type = 1;
            errMsg = "公式资源未加载完成提交";
        } else if (wfVerifiySourceObj.scriptCusSource === "loading") {
            type = 2;
            errMsg = "代码块/自定义页面未加载完成提交";
        } else if (wfVerifiySourceObj.detailData === "loading") {
            type = 3;
            errMsg = "明细表数据未加载完成提交";
        } else if (wfVerifiySourceObj.formularSource === "fail") {
            type = 1;
            errMsg = variableMap.get("formulaPathsNotFound") || "";
        } else if (wfVerifiySourceObj.scriptCusSource === "fail") {
            type = 2;
            errMsg = variableMap.get("scriptOrCustomPageError") || "";
        } else if (wfVerifiySourceObj.detailData === "fail") {
            type = 3;
            errMsg = variableMap.get("detailDataError") || "";
        }
        if(errMsg){
            await src.API_REQ.writeFormErrlog({
                requestid,
                workflowid,
                nodeid,
                operator: currentUserid,
                errlog: errMsg,
                type: type,
                isMobile: src.isMobile ? 1 : -1,
            })
        }
        
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/linkageControl.js